import { Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ModalDismissReasons, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError, debounceTime, distinctUntilChanged, map, merge, startWith, Subject, Subscription, switchMap } from 'rxjs';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnDestroy {
  [x: string]: any;
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  pageSizeOptions: number[] = [10, 25, 100];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  searchQuery = new FormControl();
  formAction = 'add'
  displayedColumns: string[] = ["username", "fname", 'lname', "email", "role", "date", "status", "action"];
  user: User = new User();
  @ViewChild("userForm")
  userForm!: NgForm;
  isSubmitted: boolean = false
  centers: any;
  roles: any;
  dateQuery = new FormControl();
  departmentsList: any;
  allUsers: any = [];
  deleteParam: any = {};
  /** Row selected for part-d permanent delete (separate from suspend flow). */
  permanentDeleteParam: any = {};
  isPermanentDeleting = false;
  permanentDeleteError: string | null = null;
  createUserError: string | null = null;

  // ── Reassign & Delete (async flow) ──────────────────────────────────────────
  reassignToUserId: number | null = null;
  isReassignDeleting = false;
  reassignDeleteError: string | null = null;
  allUsersForReassign: any[] = [];
  /** user_ids whose deletion is in progress (shows spinner on their row). */
  pendingDeletionIds: Set<number> = new Set();
  private deletionPollers: Map<number, any> = new Map();
  newPassword: any = "";
  selectedRecord: any = {};
  filterArray: any = [
    { key: 'username', value: 'Username' },
    { key: 'fname', value: 'First Name' },
    { key: 'lname', value: 'Last Name' },
    { key: 'email', value: 'Email' },
    { key: 'role', value: 'Role' },
  ];
  signatures: string[] = []; // List of signatures
  selectedIndex: number | null = null; // Currently selected signature index
  initialLoad: boolean = true;


  usernameAvailableMessage: string = '';
  usernameErrorMessage: string = '';

  private usernameChanged = new Subject<{ client_id: number; username: string }>();
  private usernameSub!: Subscription;
  isUsernameLoading: boolean = false;



  constructor(private tracker: TrackingService,private toast: ToastrService, private api: UsersService, private modalService: NgbModal, private localStorage: LocalStorageService) {


  }
  ngOnInit(): void {
    //this.getAllUsers();
  this.usernameSub = this.usernameChanged
  .pipe(
    debounceTime(500),
    distinctUntilChanged((a, b) => a.username === b.username && a.client_id === b.client_id),
    switchMap(payload => {
      this.isUsernameLoading = true;
      return this.api.checkUsernameExists(payload);
    })
  )
  .subscribe({
    next: exists => {
      this.isUsernameLoading = false;
      if (exists) {
        this.usernameAvailableMessage = '';
        this.usernameErrorMessage = 'Username already exists';
      } else {
        this.usernameErrorMessage = '';
        this.usernameAvailableMessage = 'Username is available';
      }
    },
    error: err => {
      this.isUsernameLoading = false;
      this.usernameAvailableMessage = '';
      this.usernameErrorMessage = 'Error checking username';
    }
  });

  }

  getDropdownList() {
    this.api.userModuleDropdownListing().subscribe({
      next: (res) => {
        this.centers = res.centers || []
        this.roles = res.roles || []
        this.departmentsList = res.departments || []
      },
      error: (e) => {

      }
    })
  }

  dateFilter(event: any) {
    this.dateQuery.setValue(event);
  }

  // getAllUsers() {
  //   let param = {
  //     where:{
  //       // center_id:this.localStorage.getCenterId(),
  //       client_id: parseInt(this.localStorage.getClientId())
  //     },
  //   };
  //   this.api.getAllData(param).subscribe({
  //     next: (res : any) => {
  //       this.allUsers = res || [];
  //       console.log(this.allUsers);
  //     },
  //     error: (e:any) => {
  //       console.error(e);
  //     },
  //   });
  // }

  deleteFieldModal(content: any, row: any) {
    let param = {
      ...row,
      status: "Suspended"
    }
    this.deleteParam = param;
    this.modalService.open(content, {
      size: 'l',
      scrollable: true,
      centered: true,
    });
  }

  deleteUser() {
    this.isLoading = true;
    this.api.updateUser(this.deleteParam).subscribe({
      next: (res) => {
        const desc = `User deleted: ${this.deleteParam.fname} ${this.deleteParam.lname} (${this.deleteParam.username})`;
    this.tracker.track("Delete", "User", desc); // ✅ Tracker
        this.modalService.dismissAll();
        this.isLoading = false;
        this.toast.success("User Deleted Successfully", "Success");
        this.loadData();
      },
      error: (e) => {
        this.isLoading = false;
        this.toast.error(e.error.msg, "Error");
      }
    })
  }

  isLoggedInUser(row: any): boolean {
    const id = this.localStorage.getUserId();
    return id != null && String(id) === String(row?.user_id);
  }

  openPermanentDeleteModal(content: TemplateRef<any>, row: any) {
    this.permanentDeleteParam = { ...row };
    this.isPermanentDeleting = false;
    this.permanentDeleteError = null;
    this.reassignToUserId = null;
    this.reassignDeleteError = null;
    this.loadUsersForReassign(row.user_id);
    this.modalService.open(content, { size: 'lg', scrollable: true, centered: true });
  }

  /** Load all active users (excluding the one being deleted) for the reassign dropdown. */
  loadUsersForReassign(excludeUserId: number) {
    const payload = { client_id: this.localStorage.getClientId() };
    this.api.findAllUsers(payload).subscribe({
      next: (res: any) => {
        // API may return plain array or wrapped object { rows/data: [...] }
        const list: any[] = Array.isArray(res) ? res : (res?.rows || res?.data || []);
        this.allUsersForReassign = list.filter((u: any) => {
          if (String(u.user_id) === String(excludeUserId)) return false;
          // If status is not returned by the API yet, include the user (fallback)
          if (!u.status) return true;
          return u.status === 'Active';
        });
      },
      error: () => { this.allUsersForReassign = []; }
    });
  }

  /** Handles both paths: async reassign+delete (if reassignToUserId set) or direct sync delete. */
  confirmReassignAndDelete() {
    if (this.isLoggedInUser(this.permanentDeleteParam)) {
      this.toast.error('You cannot permanently delete your own account.', 'Error');
      return;
    }

    const clientId = parseInt(String(this.localStorage.getClientId()), 10);
    const userId = this.permanentDeleteParam.user_id;

    // ── Path A: reassign selected → async flow ────────────────────────────────
    if (this.reassignToUserId) {
      this.isReassignDeleting = true;
      this.reassignDeleteError = null;
      this.api.reassignAndDeleteUser({
        user_id: userId,
        client_id: clientId,
        reassign_to_user_id: this.reassignToUserId,
      }).subscribe({
        next: (res: any) => {
          this.isReassignDeleting = false;
          this.modalService.dismissAll();
          this.pendingDeletionIds.add(userId);
          this.toast.info(
            `Reassigning leads and removing ${this.permanentDeleteParam.fname}… This may take a moment.`,
            'In progress'
          );
          this.startDeletionPolling(userId, clientId);
        },
        error: (e: any) => {
          this.isReassignDeleting = false;
          this.reassignDeleteError = e?.error?.msg || e?.error?.message || 'Failed to queue deletion.';
        },
      });
      return;
    }

    // ── Path B: no reassign → direct sync delete (original flow) ─────────────
    this.isPermanentDeleting = true;
    this.permanentDeleteError = null;
    this.api.permanentlyDeleteUser({ user_id: userId, client_id: clientId }).subscribe({
      next: (res: any) => {
        const desc = `User permanently removed: ${this.permanentDeleteParam.fname} ${this.permanentDeleteParam.lname} (${this.permanentDeleteParam.username})`;
        this.tracker.track('Delete', 'User', desc);
        this.modalService.dismissAll();
        this.isPermanentDeleting = false;
        this.toast.success(res?.message || 'User removed permanently', 'Success');
        this.loadData();
      },
      error: (e: any) => {
        this.isPermanentDeleting = false;
        const msg = e?.error?.msg || e?.error?.message || 'Permanent delete failed';
        this.permanentDeleteError = msg;
        if (e?.error?.code === 'LEADS_ASSIGNED') {
          this.reassignDeleteError = 'This user has leads assigned. Please select a user above to reassign them before deleting.';
        }
      },
    });
  }

  /** Poll getUserDeletionStatus every 4s until completed or failed. */
  startDeletionPolling(userId: number, clientId: number) {
    const interval = setInterval(() => {
      this.api.getUserDeletionStatus({ user_id: userId, client_id: clientId }).subscribe({
        next: (res: any) => {
          if (res.status === 'completed') {
            clearInterval(interval);
            this.deletionPollers.delete(userId);
            this.pendingDeletionIds.delete(userId);
            const name = this.permanentDeleteParam.fname + ' ' + this.permanentDeleteParam.lname;
            this.tracker.track('Delete', 'User', `User permanently removed (async): ${name}`);
            this.toast.success('User removed successfully.', 'Done');
            this.loadData();
          } else if (res.status === 'failed') {
            clearInterval(interval);
            this.deletionPollers.delete(userId);
            this.pendingDeletionIds.delete(userId);
            this.toast.error(res.errorMsg || 'User deletion failed. Please try again.', 'Error');
            this.loadData();
          }
          // if 'pending' → keep polling
        },
        error: () => {
          // Network hiccup — keep polling silently
        },
      });
    }, 4000);
    this.deletionPollers.set(userId, interval);
  }

  ngOnDestroy() {
    this.deletionPollers.forEach(interval => clearInterval(interval));
    this.deletionPollers.clear();
  }

  /** Close lead-warning modal and open final delete confirmation. */
  proceedToPermanentDeleteFinalConfirm(finalTpl: TemplateRef<any>) {
    this.modalService.dismissAll();
    this.permanentDeleteError = null;
    setTimeout(() => {
      this.modalService.open(finalTpl, { size: 'l', scrollable: true, centered: true });
    }, 0);
  }

  confirmPermanentDeleteUser() {
    if (this.isLoggedInUser(this.permanentDeleteParam)) {
      this.toast.error('You cannot permanently delete your own account.', 'Error');
      return;
    }
    this.isPermanentDeleting = true;
    const payload = {
      user_id: this.permanentDeleteParam.user_id,
      client_id: parseInt(String(this.localStorage.getClientId()), 10),
    };
    this.api.permanentlyDeleteUser(payload).subscribe({
      next: (res: any) => {
        const desc = `User permanently removed: ${this.permanentDeleteParam.fname} ${this.permanentDeleteParam.lname} (${this.permanentDeleteParam.username})`;
        this.tracker.track('Delete', 'User', desc);
        this.modalService.dismissAll();
        this.isPermanentDeleting = false;
        this.toast.success(res?.message || 'User removed permanently', 'Success');
        this.loadData();
      },
      error: (e: any) => {
        this.isPermanentDeleting = false;
        const msg = e?.error?.msg || e?.error?.message || 'Permanent delete failed';
        this.permanentDeleteError = msg;
      },
    });
  }

  getCenters() {
    let param = {
      where: {
        client_id: this.localStorage.getClientId(),
      }

    }
    this.api.getAllCenter(param).subscribe({
      next: (res) => {
        this.centers = res;
      }
    })
  }
  loadDepartments() {
    let param = {
      where: {
        // center_id:this.localStorage.getCenterId(),
        client_id: this.localStorage.getClientId(),
      }

    }
    this.api.getAllDepartment(param).subscribe({
      next: (res) => {
        this.departmentsList = res;
      }
    })
  }

  loadRoles() {
    let param = {
      where: {
        // center_id: parseInt(this.localStorage.getCenterId()),
        client_id: parseInt(this.localStorage.getClientId())
      }

    }
    this.api.getAllRoles(param).subscribe({
      next: (res) => {
        console.log("role", res)
        this.roles = res;
      }
    })
  }
  ngAfterViewInit() {
    this.loadData();
  }
  loadData() {
    try {
      this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      merge(this.searchQuery.valueChanges, this.sort.sortChange, this.paginator.page).pipe(startWith({}),
        switchMap(() => {
          let param = {
            where: {
              // center_id:this.localStorage.getCenterId(),
              client_id: parseInt(this.localStorage.getClientId())
            },
            page: (this.paginator.pageIndex * this.paginator.pageSize),
            limit: this.paginator.pageSize,
            filter: this.searchQuery.value,
          }
          return this.api.getAllData(param)
            .pipe(catchError(() => observableOf(null)));
        }), map((response: any) => {
          if (response === null) {
            this.initialLoad = false;
            return [];
          }

          this.totalRows = response.count;
          return response
        })
      ).subscribe({
        next: (data) => {
          this.initialLoad = false;
          console.log("Data->rows", data.rows)
          this.dataSource = new MatTableDataSource<any>(data.rows);
        },
        error: (e) => {
          console.error(e)
        },
        complete: () => {
          this.initialLoad = false;
        }
      })
    }
    catch (e) {
      this.isLoading = false;
      console.error(e)
    }
  }
  searchFilter(query: any) {
    this.searchQuery.setValue(query);
  }
  open(content: any) {
    setTimeout(() => {
      this.getCenters();
      setTimeout(() => {
        this.loadDepartments();
        setTimeout(() => {
          this.loadRoles();
        }, 1000);
      }, 1000);
    }, 1000);
    this.user = new User();
    this.formAction = "add";
    this.createUserError = null;
    this.modalService.open(content, { size: 'xl', scrollable: true })

  }
  edit(content: any, row: any) {
    setTimeout(() => {
      this.getCenters();
      setTimeout(() => {
        this.loadDepartments();
        setTimeout(() => {
          this.loadRoles();
        }, 1000);
      }, 1000);
    }, 1000);



    this.formAction = "edit";
    this.modalService.open(content, { size: 'xl', scrollable: true })
    let param = {
      user_id: row.user_id,
      client_id: this.localStorage.getClientId()
    }
    this.api.getUser(param).subscribe({
      next: (res) => {

        if (res.password) {
          delete res.password
          this.user = res;
          this.signatures = res.user_sign.map((sign: any) => sign.signature);
          this.selectedIndex = res.user_sign.findIndex((sign: any) => sign.isActive);
        }
      },
      error: (e) => {

      }
    })

  }
  fnResetPassword(content: any, element: any) {
    this.selectedRecord = element;
    console.log(element)
    this.modalService.open(content, { size: 'md', scrollable: false })
  }
  saveNewPassword() {

    if (this.newPassword != "") {
      this.isLoading = true;
      let param = {
        password: this.newPassword,
        user_id: this.selectedRecord.user_id,
        client_id: this.selectedRecord.client_id
      }
      this.api.updateUser(param).subscribe({
        next: (res: any) => {
           const desc = `Password reset for user: ${this.selectedRecord.fname} ${this.selectedRecord.lname} (${this.selectedRecord.username})`;
    this.tracker.track("Update", "User Password", desc); // ✅ Tracker
          this.loadData();
          this.modalService.dismissAll();
          this.isLoading = false;
          this.toast.success("Password Updated Successfully", 'Success')
        },
        error: (e: any) => {
          this.toast.error(e.error.msg, 'Error')
          this.isLoading = false;
        }
      })
    }
    else {
      this.toast.error("Password Field should not blank")
    }


  }
  saveUser(isValid: any) {
    this.isSubmitted = true;

    if( this.usernameErrorMessage !== '') {
      this.toast.error(this.usernameErrorMessage, 'Error');
      return;
    }

    if (isValid) {

      this.user.fname = this.capitalizeName(String(this.user.fname || ''));
      this.user.lname = this.capitalizeName(String(this.user.lname || ''));

      let user_sign: any[] = [];

      this.signatures.forEach((element, index) => {
        user_sign.push({
          signature: element,
          isActive: index === this.selectedIndex ? true : false
        })
      }
      );

      console.log("user_sign", user_sign);

      this.isLoading = true;
      this.user.client_id = this.localStorage.getClientId();
      this.user.center_id = this.localStorage.getCenterId();
      this.user.user_sign = user_sign;

      //add dept id
      if (this.formAction == 'add') {
        this.api.createUser(this.user).subscribe({
          next: (res) => {
            const desc = `User created: ${this.user.fname} ${this.user.lname} (${this.user.username})`;
            this.tracker.track("Create", "User", desc);
            this.createUserError = null;
            this.loadData();
            this.isLoading = false;
            this.modalService.dismissAll();
            this.toast.success("User Added Successfully", 'Success')
          },
          error: (e) => {
            this.isLoading = false;
            const raw = e?.error?.msg || e?.error?.message || (typeof e?.error === 'string' ? e.error : null) || 'Failed to create user';
            this.createUserError = raw.toLowerCase().includes('user limit exceeded') ? 'User limit exceeded' : raw;
          }
        })
      }
      else {
        this.api.updateUser(this.user).subscribe({
          next: (res: any) => {
            const desc = `User updated: ${this.user.fname} ${this.user.lname} (${this.user.username})`;
      this.tracker.track("Edit", "User", desc); // ✅ Tracker

            this.loadData();
            localStorage.setItem('user_sign', JSON.stringify(user_sign));
            this.modalService.dismissAll();
            this.isLoading = false;
            this.toast.success("User Updated Successfully", 'Success')
          },
          error: (e: any) => {
            this.toast.error(e.error.msg, 'Error')
            this.isLoading = false;
          }
        })
      }
    }
  }


  openSignatureModal(
    content: any,
  ) {

    if (this.signatures.length >= 3) {
      this.toast.error('You can add only 3 signatures');
      return;
    }

    this.modalService.open(content, {
      size: 'lg',
      scrollable: true,
      centered: true,
    });
  }

  previewSignature(index: number) {
    this.selectedIndex = index;
  }

  selectSignature(index: number) {
    this.selectedIndex = index;
  }

  handleModalClose(event: boolean) {
  }

  updateSignatures(updatedSignatures: any) {
    console.log("updatedSIngature", updatedSignatures);
    this.signatures.push(updatedSignatures[0]);
  }

  deleteSignature(index: number) {
    this.signatures.splice(index, 1);
  }

  previewSignatureModal(content: any, selectedIndex: number | null) {
    this.selectedIndex = selectedIndex;
    this.modalService.open(content, {
      size: 'lg',
      scrollable: true,
      centered: true,
    });
  }


  onUsernameChange(username: string): void {
    if (username && username.length > 2) {
      this.usernameChanged.next({
        client_id: this.localStorage.getClientId(),
        username
      }); // pass full payload
    } else {
      this.usernameErrorMessage = '';
      this.usernameAvailableMessage = '';
    }
  }


  showPassword: boolean = false;

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  formatNameField(field: 'fname' | 'lname'): void {
    const value = this.user[field];
    if (typeof value !== 'string') {
      return;
    }
    this.user[field] = this.capitalizeName(value);
  }

  private capitalizeName(value: string): string {
    return value
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join(' ');
  }

}
function observableOf(arg0: null): any {
  throw new Error('Function not implemented.');
}

export class User {
  user_id!: Number;
  prefix: string = "";
  fname: string = "";
  lname: string = "";
  email: string = "";
  password!: JSON;
  username: String = "";
  gender: String = "";
  picture: String = "";
  profile: String = "";
  twoFactorAuthentication: String = "";
  status: String = "";
  // client_id:String = "";
  client_id: Number = 0;
  center_id: Number = 0;
  dept_id: Number = 0;
  role_id: Number = 0;
  user_sign: any[] = [];
}
